import { initialize } from "./initialize";

export const usersMutate = {
    initialize
};